export default "__VITE_ASSET__e268572d__"